module.exports = __webpack_public_path__ + "static/media/ic-filter.9b8ed886.svg";